import React from 'react';
import styled from 'styled-components';
import { 
	string, 
	func, 
} from 'prop-types';
import '../../../i18n';
import { withNamespaces,Trans } from 'react-i18next';
import {
	Grey500,
	Grey700,
	Grey600} from '../../Colors';
import HelpBox from '../../molecules/HelpBox';
import ContainedButton from '../../atoms/ContainedButton';
import IconButton from '../../atoms/IconButton';
import {OkIcon} from '../../atoms/Icons';
import {Mobile,Default} from '../../Sizes';

const style =  {
	CreateQuizHelp : styled(HelpBox)`
		display : flex;
		align-items : center;
		justify-content : center;
		width : 100%;
	`,
	IconButton : styled(IconButton)`
		color : ${Grey500};
		&:hover{
			color : ${Grey600};
		}
	`,
	ContainedButton : styled(ContainedButton)`
		margin-right : 1rem;
		font-size : 2rem;
	`,
	OkIcon : styled(OkIcon)`
		margin-right : 1rem;
		color : ${Grey700};
	`,
};

const Help = ({
	onRequestEditQuiz,
	t
}) =>{
	const BaseComponent = ({buttonName}) => (<style.CreateQuizHelp 
		term={(<span><style.OkIcon/>{t('create-quiz.LetsMakeQuiz')}</span>)}
		description={(
			<Trans i18nKey="create-quiz.LetsMakeQuizDescription"
				values={{ name: buttonName}}
				components={[
					<style.ContainedButton key={0} onClick={onRequestEditQuiz}>
                                test
					</style.ContainedButton>]}
			>
			</Trans>)}
                    
	/>);
	BaseComponent.propTypes = {
		buttonName:string.isRequired,
	};
	return (
		<React.Fragment>
			<Mobile>
				<BaseComponent buttonName={'+'}/>
			</Mobile>
			<Default>
				<BaseComponent buttonName={t('create-quiz.CreateQuiz')}/>
			</Default>
		</React.Fragment>
		
	);
};
Help.propTypes = {
	onRequestEditQuiz:func.isRequired,
};

export default withNamespaces()(Help);